import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CustomerLogoService } from './customer-logo.service';

@Component({
  selector: 'app-customer-logo',
  templateUrl: './customer-logo.component.html',
  styleUrls: ['./customer-logo.component.css']
})
export class CustomerLogoComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('infiniteSlider', { static: false }) infiniteSlider!: ElementRef;
  @ViewChild('testimonialSlider', { static: false }) testimonialSlider!: ElementRef;
  
  allLogos: any;
  logoSlides: any[] = [];
  testimonialSlides: any[] = [];
  private sliderInterval: any;
  private testimonialSliderInterval: any;
  private sliderElement: any;
  private testimonialSliderElement: any;
  currentSlide: number = 0;
  totalSlides: number = 0;
  slideWidth: number = 0;
  currentPosition: number = 0;
  isPaused: boolean = false;
  testimonialCurrentSlide: number = 0;
  testimonialTotalSlides: number = 0;
  testimonialSlideWidth: number = 0;
  testimonialCurrentPosition: number = 0;
  testimonialIsPaused: boolean = false;
  
  // Success metrics data
  successMetrics = [
    {
      icon: 'users',
      value: '500+',
      label: 'Happy Clients',
      description: 'Organizations trust our solutions'
    },
    {
      icon: 'trending-up',
      value: '95%',
      label: 'Success Rate',
      description: 'Projects delivered on time'
    },
    {
      icon: 'globe',
      value: '25+',
      label: 'Countries',
      description: 'Global presence and reach'
    },
    {
      icon: 'award',
      value: '15+',
      label: 'Years Experience',
      description: 'Proven track record'
    }
  ];

  // Industry sectors data
  industrySectors = [
    {
      icon: 'shield',
      title: 'Defense & Security',
      description: 'Mission-critical solutions for defense forces and security agencies',
      clients: '50',
      projects: '200'
    },
    {
      icon: 'ship',
      title: 'Maritime & Logistics',
      description: 'Comprehensive maritime operations and logistics management',
      clients: '75',
      projects: '150'
    },
    {
      icon: 'factory',
      title: 'Manufacturing',
      description: 'Industrial automation and manufacturing excellence',
      clients: '100',
      projects: '300'
    },
    {
      icon: 'building',
      title: 'Infrastructure',
      description: 'Smart infrastructure and construction management',
      clients: '80',
      projects: '250'
    },
    {
      icon: 'truck',
      title: 'Transportation',
      description: 'Fleet management and transportation optimization',
      clients: '60',
      projects: '180'
    },
    {
      icon: 'heart',
      title: 'Healthcare',
      description: 'Healthcare management and patient care systems',
      clients: '40',
      projects: '120'
    }
  ];

  // Client testimonials data
  clientTestimonials = [
    {
      text: 'EPPS ERP has revolutionized our maritime operations. The system provides real-time visibility and has improved our efficiency by 40%.',
      author: 'Captain Rajesh Kumar',
      title: 'Operations Director',
      company: 'Indian Navy'
    },
    {
      text: 'The defense-grade security and comprehensive features of EPPS ERP give us confidence in managing our critical operations.',
      author: 'Colonel Priya Sharma',
      title: 'IT Director',
      company: 'Defense Ministry'
    },
    {
      text: 'Implementation was smooth and the support team is exceptional. Our manufacturing processes are now fully digitized.',
      author: 'Mr. Amit Patel',
      title: 'CEO',
      company: 'TechCorp Industries'
    }
  ];

  // Customer testimonials data for slider
  customerTestimonials = [
    {
      content: 'EPPS team members are extremely responsive and knowledgeable. They have a solid process in place for project management and are very good at ensuring that the solutions they provide, will meet all of the project requirements. EPPS SMART ERP has helped us streamline our supplies and inventories management. I would highly recommend EPPS SMART ERP to make more from a business.',
      company: 'Bony Industries',
      industry: 'Value-added Distribution Industry',
      description: 'Bony Industries is a world-class engineering company established in 1981 for producing wide range of rubber components for automotive OEMs.'
    },
    {
      content: 'EPPS SMART ERP helped us gain real time insights into our manufacturing operations and inter-company transactions. We were able to identify, define and track batch numbers of the finished goods right at the start of the production cycle. Because of the implementation of EPPS SMART ERP across all our four business units, our team was able to issue, track and receive the material without additional data capturing or administrative activities.',
      company: 'Surya Life Sciences Ltd',
      industry: 'Speciality Chemicals, Pharmaceutical RM',
      description: 'Established in the year 2002, Surya Life Sciences have carved a niche in their segment, who have earned immense appreciation as a manufacturer, exporter, and supplier of a wide assortment of highest quality bulk drug intermediates and fine API chemicals throughout the global market.'
    },
    {
      content: 'We have a mix of products and managing inventory for each one was a little difficult. Our current accounting software wasn\'t able to do it. We were looking for an ERP software that can integrate everything and give us systematic information and reports and generate bills and invoices too. We choose EPPS SMART ERP because it was exactly what we were looking for.',
      company: 'Caliper Auto Ventures',
      industry: 'Distributor of Auto Ancillary',
      description: 'Caliper Auto Ventures is a renowned name in wholesale trading of a wide range of Automotive Oil, Automotive Grease and Ball Bearing.'
    },
    {
      content: 'EPPS SMART ERP has helped us in streamlining all our processes under one unified umbrella. Digitization of information and data has brought a lot of transparency across the organization providing better control and visibility of inventories and sub-contractors. The product is extremely user-friendly and is a great value for money.',
      company: 'Jayshree Enterprises',
      industry: 'Components & Fabrication Industry',
      description: 'Jayshree Enterprises is a profound name engrossed in manufacturing 300+ precise machining components & fabrication for various types of industries. Notable customers are JCB, Chromwell, Wirtgen etc.'
    },
    {
      content: 'We have been using EPPS SMART ERP for our business operations without any problems. EPPS SMART ERP serves all facets of the business processes - Procurement, Production and Quality Management, Inventory Control and Order Management, which makes our job very easy.',
      company: 'SG Controls & Switchgear',
      industry: 'Electric Power Supply Components Industry',
      description: 'Founded in the year 2015, SG Controls & Switchgear, has been continuously excelling in the areas of manufacturing & supplying high quality switches, MCB, plugs, sockets & much more for home as well as industrial purpose.'
    },
    {
      content: 'We at HMB International needed a solution that would merge all our departments and integrate with Inventory, Finance, Sales, Purchase, Subcontracting, Manufacturing and Quality Management. The key was availability of information at the right time across all the users of the organization.',
      company: 'HMB International',
      industry: 'Tool Holding Solutions & Products',
      description: 'HMB International, which was formed in the year 2003, has been a leading manufacturer & exporter of external turning & grooving tool holder.'
    },
    {
      content: 'We are happy to be associated with EPPS SMART ERP. We needed a robust ERP that connects our operations into one integrated system and enables us to bring automation and control our processes. EPPS SMART ERP addressed our needs by providing real time control over our business operations.',
      company: 'ETE Electrogears',
      industry: 'Electric Panels Industry',
      description: 'One of the top panel manufacturing names in India ETE Electrogears has a wide industry coverage from Textiles, Automobiles, Aviation, Steel, FMCG & many more.'
    },
    {
      content: 'EPPS SMART ERP very efficiently streamlined our processes in an all-in-one solution. Our inventory, accounting, production, and sales orders were all managed under a single umbrella. This led to better manpower utilization and savings, in terms of cost and time.',
      company: 'Eden Sports',
      industry: 'Garment Industry',
      description: 'Eden Sports is a reputed organization established in the year 2004, is considered one of the leading manufacturers, traders and suppliers of a wide range of the Sports & Casual Wears.'
    },
    {
      content: 'EPPS SMART ERP has been an excellent solution that has brought efficiency to our operations. We used to manage stocks in excel, but with EPPS SMART ERP we are now able to view the stocks in one screen at the various storage locations, which helped us plan our production proficiently.',
      company: 'DMC',
      industry: 'Auto Components Industry',
      description: 'DMC is a leading global manufacturer of gasket for auto vehicles and other consumer products. They are headquartered in Korea and have subsidiaries in Japan, China and India.'
    },
    {
      content: 'EPPS SMART ERP solutions solved many problems for us. We used to incur huge manpower costs as most of our operational work was done manually. This became very frustrating, so we opted for an ERP. With EPPS SMART ERP, we not only saved on manpower, we also addressed problems of locating raw material stocks and job work process.',
      company: 'Jay Engineers',
      industry: 'Industrial Products Industry',
      description: 'Jay Engineers is a reputed organization engaged in manufacturing, exporting and service provider of a wide range of Industrial Enclosures, Cabinet Workbench, Steel Laser Cutting Service, Turret Punching Services and much more.'
    }
  ];

  constructor(private customerLogoService: CustomerLogoService) { }

  ngOnInit() {
    this.getAllCustomerLogo();
  }

  ngAfterViewInit() {
    // Initialize slider after view is ready
    setTimeout(() => {
      this.initializeSlider();
      this.prepareTestimonialSlides();
      this.initializeTestimonialSlider();
    }, 1000);
  }

  getAllCustomerLogo() {
    this.customerLogoService.getAllCustomerLogo().subscribe(response => {
      this.allLogos = response.data;
      this.prepareLogoSlides();
    });
  }

  prepareLogoSlides() {
    if (!this.allLogos || this.allLogos.length === 0) return;

    // Flatten all logos into a single array
    const allLogosFlat: string[] = [];
    this.allLogos.forEach((logoGroup: string[]) => {
      allLogosFlat.push(...logoGroup);
    });

    // Create slides with 12 logos each (2 rows of 6)
    this.logoSlides = [];
    const logosPerSlide = 12;
    const logosPerRow = 6;

    // Ensure we have enough logos to fill at least one complete slide
    if (allLogosFlat.length < logosPerSlide) {
      // If we have fewer than 12 logos, duplicate them to fill the slide
      while (allLogosFlat.length < logosPerSlide) {
        allLogosFlat.push(...allLogosFlat.slice(0, Math.min(allLogosFlat.length, logosPerSlide - allLogosFlat.length)));
      }
    }

    for (let i = 0; i < allLogosFlat.length; i += logosPerSlide) {
      const slideLogos = allLogosFlat.slice(i, i + logosPerSlide);
      
      // Ensure we have exactly 12 logos for this slide
      if (slideLogos.length < logosPerSlide) {
        // Fill remaining slots with logos from the beginning
        const remainingSlots = logosPerSlide - slideLogos.length;
        slideLogos.push(...allLogosFlat.slice(0, remainingSlots));
      }
      
      const slide = [
        slideLogos.slice(0, logosPerRow), // First row
        slideLogos.slice(logosPerRow, logosPerRow * 2) // Second row
      ];
      this.logoSlides.push(slide);
    }
  }

  initializeSlider() {
    if (!this.infiniteSlider || this.logoSlides.length === 0) return;

    const slider = this.infiniteSlider.nativeElement;
    const slideWidth = slider.offsetWidth;
    let currentPosition = 0;
    const totalSlides = this.logoSlides.length;
    let currentSlide = 0;
    let isPaused = false;

    // Set initial position
    slider.style.transform = `translateX(0px)`;

    // Add mouse events for pause/resume
    slider.addEventListener('mouseenter', () => {
      isPaused = true;
      if (this.sliderInterval) {
        clearInterval(this.sliderInterval);
      }
    });

    slider.addEventListener('mouseleave', () => {
      isPaused = false;
      this.startAutoScroll();
    });

    // Start auto-scroll
    this.startAutoScroll();

    // Store references for cleanup
    this.sliderElement = slider;
    this.currentSlide = currentSlide;
    this.totalSlides = totalSlides;
    this.slideWidth = slideWidth;
    this.isPaused = isPaused;
  }

  startAutoScroll() {
    if (this.sliderInterval) {
      clearInterval(this.sliderInterval);
    }

    this.sliderInterval = setInterval(() => {
      if (this.isPaused) return;

      this.currentSlide++;
      
      if (this.currentSlide >= this.totalSlides) {
        // Reset to first slide seamlessly
        this.currentSlide = 0;
        this.currentPosition = 0;
        this.sliderElement.style.transition = 'none';
        this.sliderElement.style.transform = `translateX(0px)`;
        
        // Force reflow
        setTimeout(() => {
          this.sliderElement.style.transition = 'transform 1s ease-in-out';
          this.currentSlide = 1;
          this.currentPosition = -this.slideWidth;
          this.sliderElement.style.transform = `translateX(${this.currentPosition}px)`;
        }, 50);
      } else {
        this.currentPosition = -this.slideWidth * this.currentSlide;
        this.sliderElement.style.transition = 'transform 1s ease-in-out';
        this.sliderElement.style.transform = `translateX(${this.currentPosition}px)`;
      }
    }, 4000); // Change slide every 4 seconds (slower)
  }

  pauseSlider() {
    this.isPaused = true;
    if (this.sliderInterval) {
      clearInterval(this.sliderInterval);
    }
  }

  resumeSlider() {
    this.isPaused = false;
    this.startAutoScroll();
  }

  // Logo slider navigation methods
  nextSlide() {
    if (this.isPaused) return;
    
    this.currentSlide++;
    if (this.currentSlide >= this.totalSlides) {
      this.currentSlide = 0;
    }
    this.moveToSlide(this.currentSlide);
  }

  previousSlide() {
    if (this.isPaused) return;
    
    this.currentSlide--;
    if (this.currentSlide < 0) {
      this.currentSlide = this.totalSlides - 1;
    }
    this.moveToSlide(this.currentSlide);
  }

  goToSlide(slideIndex: number) {
    this.currentSlide = slideIndex;
    this.moveToSlide(this.currentSlide);
  }

  moveToSlide(slideIndex: number) {
    if (!this.sliderElement) return;
    
    this.currentPosition = -this.slideWidth * slideIndex;
    this.sliderElement.style.transition = 'transform 1s ease-in-out';
    this.sliderElement.style.transform = `translateX(${this.currentPosition}px)`;
  }

  prepareTestimonialSlides() {
    if (!this.customerTestimonials || this.customerTestimonials.length === 0) return;

    // Create slides with 3 testimonials each
    this.testimonialSlides = [];
    const testimonialsPerSlide = 3;

    for (let i = 0; i < this.customerTestimonials.length; i += testimonialsPerSlide) {
      const slideTestimonials = this.customerTestimonials.slice(i, i + testimonialsPerSlide);
      this.testimonialSlides.push(slideTestimonials);
    }
  }

  initializeTestimonialSlider() {
    if (!this.testimonialSlider || this.testimonialSlides.length === 0) return;

    const slider = this.testimonialSlider.nativeElement;
    const slideWidth = slider.offsetWidth;
    this.testimonialCurrentPosition = 0;
    this.testimonialTotalSlides = this.testimonialSlides.length;
    this.testimonialCurrentSlide = 0;
    this.testimonialIsPaused = false;
    this.testimonialSlideWidth = slideWidth;

    // Set initial position
    slider.style.transform = `translateX(0px)`;

    // Store references for cleanup
    this.testimonialSliderElement = slider;

    // Start auto-scroll
    this.startTestimonialAutoScroll();
  }

  startTestimonialAutoScroll() {
    if (this.testimonialSliderInterval) {
      clearInterval(this.testimonialSliderInterval);
    }

    this.testimonialSliderInterval = setInterval(() => {
      if (this.testimonialIsPaused) return;

      this.testimonialCurrentSlide++;
      
      if (this.testimonialCurrentSlide >= this.testimonialTotalSlides) {
        // Reset to first slide seamlessly
        this.testimonialCurrentSlide = 0;
        this.testimonialCurrentPosition = 0;
        this.testimonialSliderElement.style.transition = 'none';
        this.testimonialSliderElement.style.transform = `translateX(0px)`;
        
        // Force reflow
        setTimeout(() => {
          this.testimonialSliderElement.style.transition = 'transform 1.5s ease-in-out';
          this.testimonialCurrentSlide = 1;
          this.testimonialCurrentPosition = -this.testimonialSlideWidth;
          this.testimonialSliderElement.style.transform = `translateX(${this.testimonialCurrentPosition}px)`;
        }, 50);
      } else {
        this.testimonialCurrentPosition = -this.testimonialSlideWidth * this.testimonialCurrentSlide;
        this.testimonialSliderElement.style.transition = 'transform 1.5s ease-in-out';
        this.testimonialSliderElement.style.transform = `translateX(${this.testimonialCurrentPosition}px)`;
      }
    }, 5000); // Change slide every 5 seconds (slower)
  }

  pauseTestimonialSlider() {
    this.testimonialIsPaused = true;
    if (this.testimonialSliderInterval) {
      clearInterval(this.testimonialSliderInterval);
    }
  }

  resumeTestimonialSlider() {
    this.testimonialIsPaused = false;
    this.startTestimonialAutoScroll();
  }

  // Testimonial slider navigation methods
  nextTestimonialSlide() {
    if (this.testimonialIsPaused) return;
    
    this.testimonialCurrentSlide++;
    if (this.testimonialCurrentSlide >= this.testimonialTotalSlides) {
      this.testimonialCurrentSlide = 0;
    }
    this.moveToTestimonialSlide(this.testimonialCurrentSlide);
  }

  previousTestimonialSlide() {
    if (this.testimonialIsPaused) return;
    
    this.testimonialCurrentSlide--;
    if (this.testimonialCurrentSlide < 0) {
      this.testimonialCurrentSlide = this.testimonialTotalSlides - 1;
    }
    this.moveToTestimonialSlide(this.testimonialCurrentSlide);
  }

  goToTestimonialSlide(slideIndex: number) {
    this.testimonialCurrentSlide = slideIndex;
    this.moveToTestimonialSlide(this.testimonialCurrentSlide);
  }

  moveToTestimonialSlide(slideIndex: number) {
    if (!this.testimonialSliderElement) return;
    
    this.testimonialCurrentPosition = -this.testimonialSlideWidth * slideIndex;
    this.testimonialSliderElement.style.transition = 'transform 1.5s ease-in-out';
    this.testimonialSliderElement.style.transform = `translateX(${this.testimonialCurrentPosition}px)`;
  }

  ngOnDestroy() {
    if (this.sliderInterval) {
      clearInterval(this.sliderInterval);
    }
    if (this.testimonialSliderInterval) {
      clearInterval(this.testimonialSliderInterval);
    }
  }
}
